import {DateService} from "../services/DateService";

export class OperationCard {


  public id: number;
  public code: string;
  public name: string;
  public start: Date;

  public operationCustomerDescription: string;

  public typeOfMissionName: string;

  public rolDefinitionName: string;
  public operationLogoUrl: string;
  public customerCode: string;
  public customerName: string;
  public emailManager: string;
  public urlDashboard: string;

  public agencyOperationManager: AgencyContact;

  public kpiSheets: KpiSheet[];

  public nbKits: number;
  public logaWorkDayId: number;

  public planningOpenFrom: number;
  public planningOpenUntil: number;
  public earliestPlannableDate: number;
  public latestPlannableDate: number;
  public showInvoicingInfos: boolean;
  public useSlotPlanning: boolean;

  public urlPhoto: string;
  public quotaGlobal: number;

  /**do we have a quota defined, on sectors, using a hour per profile stategy **/
  public hourQuotaDefined: boolean;

  /**do we have a quota defined, on sectors, using a budget/euro per sector allowance strategy **/
  public budgetQuotaDefined: boolean;

  /** if true, then the operation budget for quota should not be expressed in Euros, but in points, API will do the conversion**/
  public budgetQuotaInPoints: boolean;

  /**
   * flag to tell if this campagn is really time bound, from a customer planning perspective
   */
  public uiUsePlanning: boolean;

  /**
   * is the operation currently active, based on activites planned 2weeks in the past, and 2 months ahead
   */
  public currentlyActive: boolean;

  /**
   * how many days before planning is no longer available
   */
  public uiDaysBeforePlanningClosing: number;

  public uiIsPlanningClosed: boolean;


  public uiSelected: boolean;

  toggleSelected() {
    this.uiSelected = this.uiSelected ? !this.uiSelected : true;
  }


  /**
   * setup from DTO to real instance
   * @param c
   */
  setupFrom(c: OperationCard, dateService: DateService): OperationCard {


    this.id = c.id;
    this.code = c.code;
    this.name = c.name;
    this.start = c.start;
    this.rolDefinitionName = c.rolDefinitionName;
    this.operationLogoUrl = c.operationLogoUrl;
    this.customerCode = c.customerCode;
    this.customerName = c.customerName;
    this.emailManager = c.emailManager;
    this.urlDashboard = c.urlDashboard;
    this.kpiSheets = c.kpiSheets;
    this.nbKits = c.nbKits;
    this.logaWorkDayId = c.logaWorkDayId;
    this.urlPhoto = c.urlPhoto;
    this.quotaGlobal = c.quotaGlobal;
    this.agencyOperationManager = c.agencyOperationManager;
    this.typeOfMissionName = c.typeOfMissionName;
    this.planningOpenFrom = c.planningOpenFrom;
    this.planningOpenUntil = c.planningOpenUntil;
    this.earliestPlannableDate = c.earliestPlannableDate;
    this.latestPlannableDate = c.latestPlannableDate;
    this.operationCustomerDescription = c.operationCustomerDescription;
    this.currentlyActive = c.currentlyActive;
    this.showInvoicingInfos = c.showInvoicingInfos;
    this.useSlotPlanning = c.useSlotPlanning;

    this.budgetQuotaDefined = c.budgetQuotaDefined;
    this.hourQuotaDefined = c.hourQuotaDefined;
    this.budgetQuotaInPoints = c.budgetQuotaInPoints;

    // process business fields
    this.uiUsePlanning = (this.planningOpenFrom != null && this.planningOpenFrom > 0) || (this.planningOpenUntil != null && this.planningOpenUntil > 0) || (this.earliestPlannableDate != null && this.earliestPlannableDate > 0) || (this.latestPlannableDate != null && this.latestPlannableDate > 0);

    if (dateService != null) {
      const today = dateService.getToday();
      if (this.planningOpenUntil) {
        this.uiIsPlanningClosed = this.planningOpenUntil - today.dateStamp >= 0;
        this.uiDaysBeforePlanningClosing = this.planningOpenUntil - today.dateStamp;
      }
    }
    return this;
  }

  computeStatus(): string {
    if (this.uiDaysBeforePlanningClosing > 5)
      return 'status-done';
    else if (this.uiDaysBeforePlanningClosing <= 5)
      return 'status-wip';
    else if (this.uiDaysBeforePlanningClosing < 0)
      return 'status-empty';
  }

}


export class AgencyContact {
  public id: number;
  public firstName: string;
  public lastName: string;
  public email: string;
}

export class KpiSheet {
  public id: number;
  public name: string;
}



// WEBPACK FOOTER //
// ./src/model/OperationCard.ts